const showMessage = (msg, status, title, icon = null) => {
    $('#modalMessage')
        .find('.modal-icon')
        .html(icon ? `<img src="/build/images/icon-modal-${icon}.svg" alt="Icon modal" />` : '')
        .end()
        .find('.modal-content')
        .toggleClass('mt-5', !!icon)
        .end()
        .find('.modal-title')
        .html(title || window.jsLocalizations[status ? 'modal_success_title' : 'modal_error_title'])
        .toggleClass('mt-5', !!icon)
        .end()
        .find('.modal-body')
        .html(msg)
        .removeClass('text-success', 'text-danger')
        .addClass('text-' + (status ? 'success' : 'danger'))
        .end()
        .modal();
};

const showMessageForm = (route, icon = null) => {
    $('#modalForm')
        .find('.modal-icon')
        .html(icon ? `<img src="/build/images/icon-modal-${icon}.svg" alt="Icon modal" />` : '')
        .end()
        .find('.modal-content')
        .toggleClass('mt-5', !!icon)
        .end()
        .find('.modal-title')
        .toggleClass('mt-5', !!icon)
        .end()
        .find('.js-send-message')
        .attr('data-route', route)
        .end()
        .modal();
};

if (document.querySelector('.magnific')) {
    $('.magnific').magnificPopup({type: 'image'});
}
$(document).on('click', function(e) {
    if(
        !e.target.closest('.nav-links') && !e.target.classList.contains('nav-links') &&
        !e.target.closest('.burger') && !e.target.classList.contains('burger') &&
        $('.nav-links').hasClass('nav-active')
    ) {
        $('.burger').removeClass('toggle');
        $('.nav-links').removeClass('nav-active')
    }
})
$(document).on('shown.bs.modal', function () {
    $('html').addClass('modal-open')
})
$(document).on('hidden.bs.modal', function () {
    $('html').removeClass('modal-open')
})
export { showMessage, showMessageForm }
